<template>
    <div class="flex flex-wrap items-center border-b mb-2 bg-gray-super-100">
        <div class="inline-block px-4 py-2 font-bold text-base"><i class="fas fa-list mr-2"></i></div>
        <div class="inline-block ml-auto pr-4">
            <span @click="handleAdd" class="btn btn-xs btn-blue btn-shadow-none"><i class="fas fa-plus"></i><b class="ml-1">Add a new Testimonial</b></span>
        </div>
    </div>

    <div v-for="(testimonial, index) in testimonials" :class="{'border-t-0' : index > 0}" class="border p-2">
        <div class="flex flex-wrap mb-2">
            <div class="xs:w-full w-1/2 pr-2 xs:pr-0">
                <label :for="`name-` + index">Name</label>
                <input :id="`name-` + index" type="text" class="form-input form-input-sm" v-model="testimonial.name">
            </div>
            <div class="xs:w-full w-1/2 pl-2 xs:pl-0">
                <label :for="`location-` + index">Location</label>
                <input :id="`location-` + index" type="text" class="form-input form-input-sm" v-model="testimonial.location">
            </div>
        </div>
        <div class="w-full mb-2">
            <label for="description">Testimonial Description</label>
            <textarea id="description" class="form-input form-input-sm" rows="8" v-model="testimonial.description"></textarea>
        </div>
        <div @click="handleRemove(index)" class="btn btn-red btn-sm inline-block ml-auto">
            <i class="fa fa-times cursor-pointer"></i>
            Delete
        </div>
    </div>

    <div class="w-full mt-8 flex">
        <div class="inline-block pr-4">
            <button class="btn btn-yellow" @click="handleSave">Save</button>
            <a href="/admin" class="text-black ml-2 btn btn-default">Cancel</a>
        </div>
        <div class="inline-block ml-auto">
            <span @click="handleAdd" class="btn btn-blue"><i class="fas fa-plus mr-1"></i>Add a new Testimonial</span>
        </div>
    </div>

    <flash-message ref="flash"></flash-message>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
    initialTestimonials: {
        type: Array,
        required: true
    },
    section: {
        type: String,
        required: true
    }
});

const testimonials = ref(props.initialTestimonials);
const flash = ref(null);

function handleRemove(index) {
    testimonials.value.splice(index, 1);
}

function handleAdd() {
    testimonials.value.push({});
}

function handleSave() {
    const route = window.route('admin.testimonials.update', { section: props.section });
    axios.patch(route, { testimonials: testimonials.value })
        .then((response) => {
            flash.value.display('Successfully saved «Testimonials»!');
        }).catch(error => {
            flash.value.error('Error saving «Testimonials»');
        });
}
</script>
